import React, { useContext, useEffect } from 'react';
import { Link } from 'gatsby';
import { AppContextInterface } from '../custom-types';
import { AppCtx } from '../layouts';
import linkToSlug from '../utils/link-to-slug';
import { useTranslation } from 'react-i18next';

function Breadcrumbs({
  categoryTitle,
  categorySlug,
  defaultLanguage,
}: {
  categoryTitle: string;
  categorySlug: string;
  defaultLanguage: string;
}) {
  const { appContext } = useContext<AppContextInterface>(AppCtx);
  const { t } = useTranslation();

  const [isSafari, setIsSafari] = React.useState(false);
  
  useEffect(() => {
    let agent = parseUserAgent(navigator.userAgent)
    setIsSafari(agent);
  //console.log('navigator.userAgent',agent);
  }, [])


  const parseUserAgent = (pathname) => {
    const isSafari = /^((?!chrome).)*safari/i.test(pathname);
    return isSafari;
  };


  return (
    <div className={`flex flex-row  ltr:font-headline  ${isSafari ? 'rtl:font-bodyEn' : 'rtl:font-bodyAr'}`}>
      <Link to={linkToSlug({ language: appContext?.currentLanguage, defaultLanguage })} aria-label={t('home')}>{t('home')}</Link>
      <span className="mx-2">{'/'}</span>
      <Link
        to={linkToSlug({ language: appContext?.currentLanguage, defaultLanguage, slug: `category/${categorySlug}` })}
        aria-label="category-title"
      >
        {categoryTitle}
      </Link>
    </div>
  );
}

export default Breadcrumbs;
